import { FC } from 'react';

import { EnecoInHuisLeadFlowsPersonalDetailsStep } from '@eneco/flows/components';

export const PersonalDetailsStep: FC = () => (
  <EnecoInHuisLeadFlowsPersonalDetailsStep contentName="SolarBoilerLeadFlowPersonalDetailsStep" />
);
